module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('f7-page', {
    staticClass: "no-swipeback",
    attrs: {
      "login-screen": "",
      "id": "login"
    },
    on: {
      "page:reinit": function($event) {}
    }
  }, [_c('div', {
    staticClass: "body"
  }, [_c('b-row', {
    staticStyle: {
      "height": "100%"
    }
  }, [_c('div', {
    staticClass: "panel21 panel-default loginPanel loginHeight"
  }, [_c('div', {
    staticStyle: {
      "display": "inline-block",
      "vertical-align": "middle"
    }
  }, [_c('p', {
    staticClass: "col-sm"
  }, [_c('img', {
    staticClass: "logoSmallScreen",
    attrs: {
      "src": _vm.imgVars
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "panel-heading ajust"
  }, [(!_vm.activationCode) ? _c('h4', {
    staticClass: "panel-title"
  }, [_vm._v("\n              " + _vm._s(_vm.$t('loginPage.sign_in_activated')) + "\n            ")]) : _vm._e(), _vm._v(" "), (_vm.activationCode) ? _c('h4', {
    staticClass: "panel-title"
  }, [_vm._v("\n              " + _vm._s(_vm.$t('loginPage.sign_in_not_activated')) + "\n            ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.quickLogin()
      }
    }
  }, [_c('b-row', [_c('b-col', {
    staticClass: "form-group"
  }, [_c('form-write-group-label-input', {
    attrs: {
      "inputType": "text",
      "placeholderValue": _vm.loginpage_Identifier,
      "customHeight": '44'
    },
    model: {
      value: (_vm.credentials.Login),
      callback: function($$v) {
        _vm.$set(_vm.credentials, "Login", $$v)
      },
      expression: "credentials.Login"
    }
  })], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-control passwordControl",
    staticStyle: {
      "display": "flex",
      "height": "44px"
    }
  }, [((_vm.passwordFieldType) === 'checkbox') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.credentials.Password),
      expression: "credentials.Password"
    }],
    staticStyle: {
      "border": "none",
      "width": "90%"
    },
    attrs: {
      "placeholder": _vm.loginpage_Password,
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.credentials.Password) ? _vm._i(_vm.credentials.Password, null) > -1 : (_vm.credentials.Password)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.credentials.Password,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.credentials, "Password", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.credentials, "Password", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.credentials, "Password", $$c)
        }
      }
    }
  }) : ((_vm.passwordFieldType) === 'radio') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.credentials.Password),
      expression: "credentials.Password"
    }],
    staticStyle: {
      "border": "none",
      "width": "90%"
    },
    attrs: {
      "placeholder": _vm.loginpage_Password,
      "type": "radio"
    },
    domProps: {
      "checked": _vm._q(_vm.credentials.Password, null)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.credentials, "Password", null)
      }
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.credentials.Password),
      expression: "credentials.Password"
    }],
    staticStyle: {
      "border": "none",
      "width": "90%"
    },
    attrs: {
      "placeholder": _vm.loginpage_Password,
      "type": _vm.passwordFieldType
    },
    domProps: {
      "value": (_vm.credentials.Password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.credentials, "Password", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "icon icon-password",
    class: [_vm.isPasswordFieldHidden ? 'icon-eye_blind' : 'icon-eye'],
    on: {
      "click": _vm.toggleVisibility
    }
  })])])], 1), _vm._v(" "), _c('b-row', [(_vm.withPassword) ? _c('b-col', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-control passwordControl",
    staticStyle: {
      "display": "flex",
      "height": "44px"
    }
  }, [((_vm.passwordFieldType) === 'checkbox') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.credentials.PasswordRepeat),
      expression: "credentials.PasswordRepeat"
    }],
    staticStyle: {
      "border": "none",
      "width": "90%"
    },
    attrs: {
      "placeholder": _vm.loginpage_PasswordRepeat,
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.credentials.PasswordRepeat) ? _vm._i(_vm.credentials.PasswordRepeat, null) > -1 : (_vm.credentials.PasswordRepeat)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.credentials.PasswordRepeat,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.credentials, "PasswordRepeat", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.credentials, "PasswordRepeat", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.credentials, "PasswordRepeat", $$c)
        }
      }
    }
  }) : ((_vm.passwordFieldType) === 'radio') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.credentials.PasswordRepeat),
      expression: "credentials.PasswordRepeat"
    }],
    staticStyle: {
      "border": "none",
      "width": "90%"
    },
    attrs: {
      "placeholder": _vm.loginpage_PasswordRepeat,
      "type": "radio"
    },
    domProps: {
      "checked": _vm._q(_vm.credentials.PasswordRepeat, null)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.credentials, "PasswordRepeat", null)
      }
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.credentials.PasswordRepeat),
      expression: "credentials.PasswordRepeat"
    }],
    staticStyle: {
      "border": "none",
      "width": "90%"
    },
    attrs: {
      "placeholder": _vm.loginpage_PasswordRepeat,
      "type": _vm.passwordFieldType
    },
    domProps: {
      "value": (_vm.credentials.PasswordRepeat)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.credentials, "PasswordRepeat", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "icon icon-password",
    class: [_vm.isPasswordFieldHidden ? 'icon-eye_blind' : 'icon-eye'],
    on: {
      "click": _vm.toggleVisibility
    }
  })])]) : _vm._e()], 1), _vm._v(" "), (!_vm.withPassword) ? _c('b-row', {
    staticClass: "form-group"
  }, [_c('a', {
    staticStyle: {
      "margin-left": "20px"
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.resetPassword
    }
  }, [_vm._v("Mot de passe oublié ?")])]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "loginButtons",
    style: (_vm.cssVars)
  }, [_c('button', {
    staticClass: "logButton loginButton",
    on: {
      "click": function($event) {
        return _vm.authUser()
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('loginPage.lgn_on_login_page')) + "\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "login-method-separator"
  }, [_vm._v("\n            " + _vm._s(_vm.$t('common.or_label_maj')) + "\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "loginButtons"
  }, [_c('button', {
    staticClass: "logButton loginGoogleButton",
    on: {
      "click": _vm.handleClickSignIn
    }
  }, [_c('span', {
    staticStyle: {
      "vertical-align": "middle",
      "font-size": "13px"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t('loginPage.login_ggl_sso')) + "\n              ")])])]), _vm._v(" "), _c('hr', {
    staticStyle: {
      "margin-top": "30px"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "signupLink",
    attrs: {
      "href": "/register/"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.rgstr')))]), _vm._v(" "), _c('cm-account-activation-popup', {
    attrs: {
      "credentials": _vm.credentials
    }
  })], 1)])])], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-55b07750", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-55b07750","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/user/CMLogin.vue
// module id = 2420
// module chunks = 2